import type {SessionQuestion} from '@cp/model';
import {updateDoc} from 'firebase/firestore';
import getQuizSessionDoc from './getQuizSessionDoc';
import {getQuizSessionDocRef} from './getQuizSessionDocRef';

/**
 * Update one question's selectedAnswer in the session doc.
 * The trigger quizSessionOnUpdate will run on this write, compute isCorrect, update progress and streak.
 */
export default async function updateQuizQuestionAnswerDoc(
  uid: string,
  sessionId: string,
  questionId: string,
  selectedAnswer: string,
): Promise<void> {
  const session = await getQuizSessionDoc(uid, sessionId);
  if (!session) {
    throw new Error('Session not found');
  }
  if (session.endedAt) {
    throw new Error('Session has ended');
  }

  const updatedQuestions: SessionQuestion[] = session.questions.map((q) => {
    if (q.id !== questionId) return q;
    return {...q, selectedAnswer, isCorrect: q.answer === selectedAnswer};
  });

  const ref = getQuizSessionDocRef(uid, sessionId);
  return updateDoc(ref, {questions: updatedQuestions});
}
